import styled from 'styled-components'
import Icon from '@/components/icon'
import { colors } from '@/styles'

const BackIcon = styled(Icon)`
  cursor: pointer;
  :hover {
    opacity: 0.7;
  }
`

export const TextButton = styled.button`
  color: ${props => (props.delete ? colors.primary : colors.link)};
  background: transparent;
  border: none;
  font-size: 16px;
  cursor: pointer;
  transition: opacity 0.2s ease-in-out;
  outline: none;

  :hover {
    opacity: 0.7;
  }
`

export const BackButton = ({ back }) => (
  <BackIcon aria-label="Close" id="back_grey" width={24} height={24} onClick={back} />
)

export const CardWrapper = styled.button`
  height: 100%;
  width: 100%;
  overflow-x: hidden;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 8px 0;
  background-color: ${colors.white};
  box-shadow: 0px 4px 6px -2px rgba(0, 0, 0, 0.06);
  border: 1px solid ${colors.grey88};
  border-radius: 6px;
  padding: 16px;
  cursor: pointer;
  transition: background-color 300ms ease-in-out 0s, box-shadow 300ms ease-in-out 0s;
  &:not(:disabled) {
    &:hover,
    &:focus {
      box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05);
    }
  }
`
